<template>
    <rkm-overlay>
        <rkm-layout-body title="Dispensação de materiais">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="outline-success"
                >
                    Finalizar
                </rkm-button>
            </template>

            <template
                v-if="paciente"
                v-slot:subtitle
            >

                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ paciente.cidadao.nome }} <strong>({{ paciente.cidadao.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ paciente.cidadao.nome }},
                    </span>
                    <span v-if="paciente.cidadao.idade">
                        {{ paciente.cidadao.idade.anos }} anos,
                        {{ paciente.cidadao.idade.meses }} meses
                        e {{ paciente.cidadao.idade.dias }} dias,
                    </span>
                    <span>{{ paciente.cidadao.sexo.descricao }}</span>
                </div>
            </template>

            <rkm-layout-content>
                <Form
                    :pacienteId="pacienteId"
                    ref="Form"
                    @save="handleSave"
                    @paciente="handlePaciente"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/almoxarifado/dispensacao-materiais/Form'

// Vuex.
import { mapActions } from 'vuex'

// Enums
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    data: () => ({
        paciente: null,
        enums: {
            preferenciaNome
        }
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {
            this.showExitConfirmation(async () => {
                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {
            this.$router.push({ name: 'almoxarifado-dispensacao-materiais-index' })
        },
        handlePaciente(paciente) {
            this.paciente = paciente
        }
    },
    props: {
        pacienteId: { type: Number, default: null }
    },
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>